export const responseProjectEtag = (response: Response): string => {
    const value = response.headers.get("ETag");
    const match = value ? /^(?:W\/)?"([1-9][0-9]*)"$/u.exec(value) : null;
    if (!match) throw new Error("PROJECT_ETAG_INVALID");
    return `"${match[1]}"`;
};

export const hasNewerProjectVersion = (currentEtag: string, serverVersion: number): boolean =>
    serverVersion > Number(currentEtag.slice(1, -1));
